var EMRPatientSearchForHAM = angular.module('EMR.PatientSearchForHAMModule', [])

var PatientSearchForHAMModulesInfo = [
    {
        moduleId: 1,
        name: "Patient_Search_For_HAM_Popup_Comp",
        url: "/Patient_Search_For_HAM_Popup_Comp",
        component: "emrPatientSearchForHamPopupComp",
        template: "<emr-patient-search-for-ham-popup-comp></emr-patient-search-for-ham-popup-comp>",
        preloadModules: "",
        files: [
            "AngularScripts/PatientSearchForHAM/Components/patient-search-for-ham.module.js",
            "AngularScripts/PatientSearchForHAM/Components/patient-search-for-ham.service.js",
            "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
            "AngularScripts/PatientSearchForHAM/Components/patient-search-for-ham-popup.comp.js",
        ]
    }
];

modulesInfo = [...modulesInfo, ...PatientSearchForHAMModulesInfo];